__webpack_require__.b = self.location + "";

// no installed chunks

// no chunk install function needed
// no chunk loading

// no HMR

// no HMR manifest